import axios from 'axios';
import constants from '../../config/constants';

export const GET_ALL_GUARDIANS = 'GET_ALL_GUARDIANS';
export const GET_GUARDIAN = 'GET_GUARDIAN';
export const GET_SCHOOL_GUARDIANS = 'GET_SCHOOL_GUARDIANS';
export const GET_UNMAPPED_GUARDIANS = 'GET_UNMAPPED_GUARDIANS';

//= ========== Reducer call functions begin ===========//
export const getAllGuardians = guardiansData => ({
  type: GET_ALL_GUARDIANS,
  guardiansData,
});

export const getSchoolGuardians = guardians => ({
  type: GET_SCHOOL_GUARDIANS,
  guardians,
});

export const getGuardian = guardian => ({
  type: GET_GUARDIAN,
  guardian,
});

export const getUnMappedGuardians = guardians => ({
  type: GET_UNMAPPED_GUARDIANS,
  guardians,
});
//= ========== Reducer call functions begin ===========//
// 1800123330
//= ========== User routing begin ===========//
export const fetchAllGuardiansService = data => async dispatch => {
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/admin/get-all-guardian-by-page/${data.schoolId}/${
        data.batchId
      }${constants.makeParams(data.pageParams)}`,
      constants.setHeader(data.token)
    );
    return dispatch(getAllGuardians(res.data));
  } catch (err) {
    console.error(err.response);
  }
};

export const fetchSchoolGuardiansService = data => async dispatch => {
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/admin/get-all-guardian/${data.schoolId}`,
      constants.setHeader(data.token)
    );
    return dispatch(getSchoolGuardians(res.data));
  } catch (err) {
    console.error(err.response);
  }
};

export const saveGuardianService = data => () => {
  return axios.post(
    `${constants.API_BASE_URL}/api/admin/create-guardian`,
    data.postData,
    constants.setHeader(data.token)
  );
};

export const fetchGuardianService = data => async dispatch => {
  const res = await axios.get(
    `${constants.API_BASE_URL}/api/admin/get-guardian/${data.guardianId}`,
    constants.setHeader(data.token)
  );
  return dispatch(getGuardian(res.data));
};

export const updateGuardianService = data => () => {
  return axios.put(
    `${constants.API_BASE_URL}/api/admin/update-guardian/${data.guardianId}`,
    data.postData,
    constants.setHeader(data.token)
  );
};

export const deleteGuardianService = data => () => {
  return axios.delete(
    `${constants.API_BASE_URL}/api/admin/delete-guardian/${data.guardianId}`,
    constants.setHeader(data.token)
  );
};

export const fetchUnMappedGuardiansService = data => async dispatch => {
  const res = await axios.get(
    `${constants.API_BASE_URL}/api/admin/get-all-unmapped-guardian/${data.schoolId}`,
    constants.setHeader(data.token)
  );
  dispatch(getUnMappedGuardians(res.data));
  return res.data;
};
//= ========== User routing end ===========//
